import { createContext } from 'react';

// ----------------------------------------------------------------------

export const AuthContext = createContext({ authenticated: 'DEFAULT_VALUE' });
